import React from 'react';
import ReactGA from 'react-ga';
import { getUserInformation } from './Login/loginService';
import { getAccountName } from './Utils/UserFunctions';

/**
 * Componente Abstracto para definir funciones comunes en los componetes (paginas) de la webapp.
 * Use este componente para las paginas principales que desean reaccionar al hashChange
 * entre otras funcionalidades como tambien numberFormmater.
 * @author Luciano Bustos
 */
class OLYWebPageComponent extends React.Component {
    constructor(props, pName) {
        super(props);
        this.currentUser = getUserInformation();
        this.ischild = false;
        this.pageTitle = 'OLY WebPage Component';
        this.pageName = pName || 'OLYWebPageComponent';
        this.pageReference = 'olympia.com/help/OLYWebPageComponent.html';
        //esto me da el host-account name b2b-XYZ-web
        this.accountName = getAccountName().toLowerCase();
    }

    getUserLang() {
        if (this.currentUser && this.currentUser.user_detail && this.currentUser.user_detail.language) {
            return this.currentUser.user_detail.language;
        }
        return process.env.REACT_APP_DEFAULT_LANGUAGE;
    }

    pageTitleParts() {
        //esto busca el titulo traducido de la pagina
        if (this.props.t) {
            this.pageTitle = this.props.t('PAGE_TITLES.' + this.pageName);
        }
        return ['Olympia - B2B', this.pageTitle];
    }

    componentDidMount() {
        window.addEventListener('hashchange', this.__hashChanged, false);
        this.__hashChanged();
    }
    componentWillUnmount() {
        window.removeEventListener('hashchange', this.__hashChanged, false);
    }
    getIsHome() {
        let hash = window.location.hash;
        //este es el unico caso que consideramos home
        return (hash.indexOf('#/search') != -1 || hash === '#/');
    }
    /**
     * EventHandler.
     * Parsea el hash y lo devuelve como un objeto para poder ser utilizado.
     * usted debe implementar el handler <onHashChanged>
     */
    __hashChanged = () => {
        let hash = window.location.hash ? window.location.hash : '';
        let rawhash = window.location.hash ? window.location.hash : '';
        let ishome = this.getIsHome();
        hash = hash.replace(/\?.+/, '');
        let parts = hash.split('/');
        parts = parts ? parts.filter(part => part !== '#') : parts;
        let querystrings = rawhash.replace(hash, '');
        let queryobj = this.__getQueryStringAsObj(querystrings);
        if (this.onHashChanged) {
            this.onHashChanged({ hash: hash, parts: parts, home: ishome, query: queryobj });
        }
        if (this.pageName !== 'OLYWebPageComponent') {
            if (!this.ischild) {
                this.updatePageTitle();
            }
            ReactGA.pageview(this.pageName);
        }
    };

    /**
     * Obtienen el querystring como un objeto.
     * 
     */
    __getQueryStringAsObj = (queryString) => {
        var obj = {};
        if (queryString.indexOf('?') === -1) {
            return obj;
        }
        queryString = queryString.substr(queryString.indexOf('?') + 1);
        var pairs = queryString.split('&');
        for (var i in pairs) {
            var split = pairs[i].split('=');
            obj[decodeURIComponent(split[0])] = decodeURIComponent(split[1]);
        }
        return obj;
    }

    updatePageTitle = () => {
        document.title = this.pageTitleParts().join(' / ');
    }
    /**
     * Add error to state es una funcion que analiza los jsonErrors y los agrega en 
     * state.errors.
     * NOTE: Mi recomendacion es que llamemos al API con el DTO vacio para ver el formato y sus claves.
     * 
     * jsonError.fields: [
     *  {dataPath:'loginName'},
     *  {dataPath:'loginPassword'}
     * ]
     * 
     * To see the content please use.
     * 
     * <code>{JSON.stringify(this.state.errors)}</code>
     * 
     */
    addErrorsToStateObject = (jsonError, stateObject) => {
        if (stateObject && jsonError) {
            if (!stateObject.errors) {
                stateObject.errors = {};
            }
            if (jsonError && jsonError.fields && Array.isArray(jsonError.fields)) {
                jsonError.fields.map(field => {
                    let fname = String(field.dataPath).replace(/\./ig, '');
                    stateObject.errors[fname] = true;
                    stateObject.errors[fname + 'Description'] = field.message;
                });
            } else {
                stateObject.error = {};
            }
        }
    }
}
export default (OLYWebPageComponent);


// WEBPACK FOOTER //
// ./src/components/OLYWebPageComponent.js